module.exports = __webpack_public_path__ + "img/xHover.ecd08524.svg";